<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-hidden="true" :id="id">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-if="!picture_id">画像アップロード</h5>
                    <h5 class="modal-title" v-else>画像データ編集</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="mb-3">
                        既存画像は、画像の属性のみ変更できます。
                        画像そのものを差し替えることはできません。
                    </div>
                    <div class="d-flex justify-content-center flex-wrap">
                        <div class="btn-group file-selector mr-2 my-3" v-if="!file.id">
                            <label class="btn btn-secondary" style="margin: 0;" for="image">
                                <i class="fas fa-file-image"></i>
                                画像選択...
                                <input type="file" id="image" ref="image" @change="fileSelected()" accept="image/*" class="d-none" />
                            </label>
                            <button type="button" @click="removeImage" class="btn btn-light">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="my-3">
                            <div class="btn-group">
                                <label class="btn btn-outline-success m-0" :class="{active: file.for_background}">
                                    <input type="checkbox" v-model="file.for_background" class="d-none">
                                    <i class="fas fa-check-circle" v-if="file.for_background"></i>
                                    <i class="far fa-circle" v-else></i>
                                    背景用
                                    <i class="far fa-image"></i>
                                </label>
                                <label class="btn btn-outline-success m-0" :class="{active: file.for_portal}">
                                    <input type="checkbox" v-model="file.for_portal" class="d-none">
                                    <i class="fas fa-check-circle" v-if="file.for_portal"></i>
                                    <i class="far fa-circle" v-else></i>
                                    ポータル用
                                    <i class="fas fa-home"></i>
                                </label>
                                <label class="btn btn-outline-success m-0" :class="{active: file.for_novel}">
                                    <input type="checkbox" v-model="file.for_novel" class="d-none">
                                    <i class="fas fa-check-circle" v-if="file.for_novel"></i>
                                    <i class="far fa-circle" v-else></i>
                                    小説表紙用
                                    <i class="fas fa-book"></i>
                                </label>
                                <label class="btn btn-outline-success m-0" :class="{active: file.for_banner}">
                                    <input type="checkbox" v-model="file.for_banner" class="d-none">
                                    <i class="fas fa-check-circle" v-if="file.for_banner"></i>
                                    <i class="far fa-circle" v-else></i>
                                    バナー用
                                    <i class="far fa-flag"></i>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="my-3 d-flex justify-content-center">
                        <input type="text" v-model="file.license" class="form-control" placeholder="ライセンス文言">
                    </div>
                    <div class="my-3 d-flex justify-content-end">
                        <button type="button" class="btn btn-outline-primary" :disabled="!file.url" @click="save()">
                            <i class="fas fa-check"></i>
                            保存
                        </button>
                    </div>
                    <div class="my-3 d-flex justify-content-center" v-if="file.url">
                        <img :src="file.url" class="img-fluid img-thumbnail">
                    </div>
                </div>
            </div>
        </div>
        <loading
            v-model:active="isLoading"
            :can-cancel="false"
            :is-full-page="true"></loading>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            default: "picture-uploader"
        },
        picture_id: {
            default: null,
        }
    },
    data() {
        return {
            file: {
                license: "",
                url: null,
                info: null,
            },
            isLoading: false,
        }
    },
    methods: {
        load() {
            if (!this.picture_id) {
                this.file = {
                    license: "",
                    url: null,
                    info: null,
                };
                return;
            }
            axios.get("/admin/picture/get", {params: {id: this.picture_id}}).then(res => {
                this.file = res.data;
            }).catch(err => { alert.err(err.response) });
        },
        fileSelected() {
            if (this.$refs.image.files[0].size > 3 * 1024 * 1024) {
                console.error("file selected error");
                alert.err("ファイルサイズが大きすぎます: " + this.getSize(this.$refs.image.files[0].size));
                return;
            }
            this.file.info = this.$refs.image.files[0];
            this.file.url = URL.createObjectURL(this.file.info);
        },
        removeImage() {
            this.file.info = null;
            this.file.url = "";
        },
        save() {
            const fd = new FormData();
            if (!this.file.id) {
                fd.append('info', this.file.info);
                fd.append('url', this.file.url);
            } else {
                fd.append('id', this.file.id);
            }
            fd.append('for_background', this.file.for_background ? 1 : 0);
            fd.append('for_portal', this.file.for_portal ? 1 : 0);
            fd.append('for_novel', this.file.for_novel ? 1 : 0);
            fd.append('for_banner', this.file.for_banner ? 1 : 0);
            fd.append('license', this.file.license || "");
            this.isLoading = true;
            axios.post("/admin/picture/upload", fd).then(res => {
                this.file = {
                    license: "",
                }
                $("#" + this.id).modal("hide");
                this.$emit("load");
                this.isLoading = false;
            }).catch(err => {
                this.isLoading = false;
                alert.err(err.response);
            });
        },
        getSize(filesize) {
            if (filesize >= 1073741824) {
                return Math.round(filesize / 1073741824 * 100) / 100 + "GB";
            } else if (filesize >= 1048576) {
                return Math.round(filesize / 1048576 * 100) / 100 + "MB";
            } else if (filesize >= 1024) {
                return Math.round(filesize / 1024 * 100) / 100 + "KB";
            }
            return filesize + "B";
        },
    },
    mounted() {
        $("#" + this.id).on("show.bs.modal", (e) => {
            this.load();
        });
    }
}
</script>